import { NewApplicationStatus, NewApplicationStatusResponse } from '../types/responses/NewApplicationStatus';
import { ApplicationStatus, ApplicationStatusResponse } from '../types/responses/ApplicationStatus';

export class ApplicationStatusMapper {
    static mapData(response: NewApplicationStatusResponse): ApplicationStatusResponse {
        if (!response?.applications || !Array.isArray(response.applications)) {
            return {
                BearerToken: { access_token: null },
                ApplicationStatus: [],
            };
        }

        const mappedApplications: ApplicationStatus[] = response.applications.map((app: NewApplicationStatus) => {
            const status = this.mapStatus(
                app.applicationStatus.applicationStatus, 
                app.applicationStatus.statusDescription,
            );

            return {
                ApplicationId: app.applicationId,
                ProductName: app.card?.name || 'Credit Card',
                ReservationNumber: app.reservationNumber || '',
                Status: status,
                ReceivedDate: app.receivedDateTime ?new Date(app.receivedDateTime).toISOString() : '',
                MailDate: app.cardShippingInfo?.cardShippedDate ?new Date(app.cardShippingInfo?.cardDeliveryDate).toISOString() : '',
                ArrivalDate: app.cardShippingInfo?.cardDeliveryDate ?new Date(app.cardShippingInfo?.cardDeliveryDate).toISOString() : '',
                WasCardMailed: app.cardShippingInfo?.cardShipped || false,
                IsNotEnrolledInCreditProtectionOffer: !app.enrollments?.creditProtectionEnrolled || false,
                fundingAttempts: app.fundingAttempts,
                rawApplicationData: app,
            } as ApplicationStatus;
        });

        return {
            //will need to be handled separately if required
            BearerToken: { access_token: null },
            ApplicationStatus: mappedApplications,
        };
    }

    private static mapStatus(status: string, statusDescription: string): string {
        if (status?.toUpperCase()?.includes('READY TO FUND') || statusDescription?.toUpperCase()?.includes('READY TO FUND')) {
            return 'READY TO FUND';
        }

        if (status?.toUpperCase()?.includes('APPROVED')) {
            return 'APPROVED';
        }

        if (status?.toUpperCase()?.includes('PENDING') || status?.toUpperCase()?.includes('SOFTDECLINE') || status?.toUpperCase()?.includes('ERROR')) {
            return 'IN PROCESS';
        }

        if (status?.toUpperCase()?.includes('MISSING INFORMATION')) {
            return 'MISSING INFORMATION';
        }

        if (status?.toUpperCase()?.includes('DECLINED') || status?.toUpperCase()?.includes('HARDDECLINE')) {
            return 'DECLINED';
        }

        if (status?.toUpperCase()?.includes('CANCELLED')) {
            return 'CANCELLED';
        }

        return 'IN PROCESS';
    }

    static shouldRedirectToPendingDecision(application: NewApplicationStatus): boolean {
        return application.fundingAttempts?.achAttemptsExceeded && 
            application.fundingAttempts?.debitAttemptsExceeded &&
            !application.applicationStatus?.applicationStatus?.toUpperCase()?.includes('DECLINED');
    }

    static getAvailableFundingMethods(application: NewApplicationStatus): {
        achAvailable: boolean;
        debitAvailable: boolean;
    } {
        return {
            achAvailable: !application.fundingAttempts?.achAttemptsExceeded,
            debitAvailable: !application.fundingAttempts?.debitAttemptsExceeded,
        };
    }

    static hasRemainingAttempts(application: NewApplicationStatus): boolean {
        const available = this.getAvailableFundingMethods(application);
        return available.achAvailable || available.debitAvailable;
    }

    static buildFlowApplicationDataFromStatus = (applicationData: NewApplicationStatus): Record<string, any> => {
        const flowApplicationData: any = { ...applicationData };
    
        flowApplicationData.programCode = applicationData.card?.programCode;
        flowApplicationData.offerSecuredCard = applicationData.card?.keyCardFeatures?.cardType === 'SECURED_CARDS';
        flowApplicationData.IsSecuredCard = flowApplicationData.offerSecuredCard;
        flowApplicationData.IsMailingHomeAddressSame = applicationData.parties?.[0]?.addresses?.length === 1;
    
        return flowApplicationData;
    };

}
